module.exports = __webpack_public_path__ + "static/media/idea.b3e190cd.svg";